export default { sha: '53adeca5a3264ecafc32942f312dcd2cc93ea16f', buildNumber: 'undefined' }
